package com.neurobs.react

import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.html.{className, style, table, tbody, td, tr}

import scala.scalajs.js.Any

object GapSize extends Enumeration {
	val Small, Medium, Large = Value
}

object HoriAlign extends Enumeration {
	val Left = Value("left")
	val Center = Value("center")
	val Right = Value("right")
}

/**
 * Borderless "table" that puts spaces between content cells. There is no outer margin.
 */
@react object LayoutTable {
	case class Props(gapSize: GapSize.Value, fullWidth: Boolean, children: ReactElement*)

	val component = FunctionalComponent[Props] { props =>
		val styles = if (props.fullWidth)
			StyleUtil.makeStyle(("display", "table"), ("width", "100%"))
		else
			StyleUtil.makeStyle(("display", "inline-table"))

		table(className := tableClassName, style := styles)(
			tbody(className := tbodyClassName(props.gapSize))(
				props.children:_*
			)
		)
	}

	private def tbodyClassName(size: GapSize.Value): String = size match {
		case GapSize.Small => "small"
		case GapSize.Medium => "medium"
		case GapSize.Large => "large"
	}
	private val tableClassName = "lt"

	def alignStyle(align: HoriAlign.Value): (String, Any) = ("textAlign", align.toString)
}

@react object LTFullRow {
	case class Props(align: HoriAlign.Value, children: ReactElement*)
	val component = FunctionalComponent[Props] { props =>
		tr(
			td(style := StyleUtil.makeStyle(LayoutTable.alignStyle(props.align)))(
				props.children:_*
			)
		)
	}
}

@react object LTRow {
	case class Props(children: ReactElement*)
	val component = FunctionalComponent[Props] { props =>
		tr(props.children:_*)
	}
}

@react object LTCell {
	case class Props(align: HoriAlign.Value, children: ReactElement*)
	val component = FunctionalComponent[Props] { props =>
		td(style := StyleUtil.makeStyle(LayoutTable.alignStyle(props.align)))(
			props.children:_*
		)
	}
}